module.exports = "<section class=\"promo-list\">\r\n  <div class=\"promo-list-container\">\r\n    <h1>Promos</h1>\r\n    <div *ngFor=\"let promo of promos\">\r\n        <div class=\"promo\">\r\n          <h2>{{ promo.title }} | {{ promo.offerTitle }}</h2>\r\n          <p class=\"lifespan\"> {{ promo.lifespan }}</p>\r\n          <p class=\"promo-content\">{{ promo.description }}</p>\r\n          <p class=\"promo-exception\">{{ promo.exceptions }}</p>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/promo/promo-list/promo-list.component.html
// module id = ./src/app/promo/promo-list/promo-list.component.html
// module chunks = main